import React, { useState, useRef, useEffect, } from 'react';


import axios from 'axios';
import { useParams } from 'react-router-dom';
import useGetState from '../../hooks/useGetState';
import { useContext } from 'react';
import { CartContext } from '../../context/CartContext';
import { ServiceContext } from '../../context/ServiceContext';

import { useNavigate } from 'react-router-dom';


function OrderReview() {
    const navigate = useNavigate();
    
  
    const [firstLanguage, setFirstLanguage] = useState(null);
    const [secondLanguage, setSecondLanguage] = useState(null);
    const [Orders, setOrders] = useState([]);
    const [notes, setNotes] = useState('');

    const [storeId, setStoreId] = useState(null);
    const [storeAddress, setStoreAddress] = useState(null);
    const [storePhone, setStorePhone] = useState(null);
    const [storeImg, setStoreImg] = useState(null);
    const [storeTimetable, setStoreTimetable, getStoreTimetable] = useGetState(null);
    const [serviceType, setServiceType] = useState(null);

    const [showNoteBox, setShowNoteBox] = useState(false);
    const [note, setNote] = useState('');
    const [surcharges, setSurcharges] = useState([]);
    const [totalPromotionAmount, setTotalPromotionAmount] = useState(0);
    const [promotionTitle, setPromotionTitle] = useState('');
  
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalItemQuantity, setTotalItemQuantity] = useState(0);
    const {  serviceMode, setServiceMode, storeName, setStoreName,language, uiLanguage} = useContext(ServiceContext);
    
    // Customer Menu Show Price state
    const [showPriceInCustomerMenu, setShowPriceInCustomerMenu] = useState(true);
  

    const [side_popup, setSide_popup] = useState(false);
   

    const toggleSidePopup = () => {
        setSide_popup(!side_popup);
    };
  

  const { restaurantUrl, tableNo  } = useParams();
  

  const translations = {
    en: {
        openingHours: 'Opening Hours',
        learnMore: 'Learn more',
        orderSummary: 'Order Summary',
        menuItems: 'Menu Items',
        total: 'Total (incl. GST)',
        gst: 'GST',
        toPay: 'To Pay',
        placeOrder: 'Place Order',
        notes: 'Notes',
        addNote: 'Add a note...',
        surcharge: 'Surcharge',
        notes: 'Notes',
        tableNo: 'Table No',
        dinein: 'Dine-in',  
        takeaway: 'Takeaway',
        orderMore: 'Order More',
    },
    ja: {
        openingHours: '営業時間',
        learnMore: 'もっと詳しく',
        orderSummary: '注文概要',
        menuItems: 'メニューアイテム',
        total: '合計 (税込み)',
        gst: '消費税',
        toPay: '支払う',
        placeOrder: '注文する',
        notes: 'ノート',
        addNote: 'ノートを追加...',
        surcharge: 'サーチャージ',
        notes: 'ノート',
        tableNo: 'テーブル番号',
        dinein: '店内飲食',
        takeaway: 'テイクアウト',
        orderMore: '追加注文',
    },
    zh: {
        openingHours: '营业时间',
        learnMore: '了解更多',
        orderSummary: '订单概览',
        menuItems: '菜品',
        total: '总计 (含GST)',
        gst: '消费税',
        toPay: '支付',
        placeOrder: '下单',
        notes: '备注',

        
        addNote: '添加备注...',
        surcharge: '附加费',
        notes: '备注',
        tableNo: '桌号',
        dinein: '堂食',
        takeaway: '外卖',
        orderMore: '继续点餐',
    },
    ko: {
        openingHours: '영업 시간',
        learnMore: '더 알아보기',
        orderSummary: '주문 요약',
        menuItems: '메뉴 항목',
        total: '합계 (GST 포함)',
        gst: '부가세',
        toPay: '지불',
        placeOrder: '주문하기',
        notes: '노트',
        addNote: '노트 추가...',
        surcharge: '추가 요금',
        notes: '노트',
        tableNo: '테이블 번호',
        dinein: '매장 식사',
        takeaway: '포장',
        orderMore: '추가 주문',
    },
   
    vi: {
        openingHours: 'Giờ mở cửa',
        learnMore: 'Tìm hiểu thêm',
        orderSummary: 'Tóm tắt đơn hàng',
        menuItems: 'Mục menu',
        total: 'Tổng cộng (bao gồm GST)',
        gst: 'Thuế GTGT',
        toPay: 'Thanh toán',
        placeOrder: 'Đặt hàng',
        notes: 'Ghi chú',   
        addNote: 'Thêm ghi chú...',
        surcharge: 'Phụ phí',
        notes: 'Ghi chú',
        tableNo: 'Số bàn',
        dinein: 'Dine-in',
        takeaway: 'Takeaway',
        orderMore: 'Đặt thêm',

    },
    th: {
        openingHours: 'เวลาเปิด-ปิด',
        learnMore: 'เรียนรู้เพิ่มเติม',
        orderSummary: 'สรุปการสั่งซื้อ',
        menuItems: 'รายการเมนู',
        total: 'รวม (รวมภาษีมูลค่าเพิ่ม)',
        gst: 'ภาษีมูลค่าเพิ่ม',
        toPay: 'ชำระเงิน',
        placeOrder: 'สั่งซื้อ',
        notes: 'บันทึก',
        addNote: 'เพิ่มบันทึก...',
        surcharge: 'ค่าธรรมเนียมเพิ่ม',
        notes: 'บันทึก',
        tableNo: 'หมายเลขโต๊ะ',
        dinein: 'ทานในร้าน',
        takeaway: 'ห่อกลับ',
        orderMore: 'สั่งเพิ่ม',
    },


};
const ClickOrderMoreButton = async () => {
    try {
        
        navigate(`/qr_order/${restaurantUrl}/${tableNo}`, { state: { orderingMore: true } });
    } catch (error) {
        console.error(error);
    }
}
const ui = (key) => translations[uiLanguage] ? translations[uiLanguage][key] : translations['en'][key];

    
  useEffect(() => {
    // 当组件加载完成后，滚动到页面顶部
    window.scrollTo(0, 0);
}, []);


    useEffect(() => {
        // 定义一个内部的异步函数
        const fetchStoreConfig = async () => {
            
            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchStoreConfig/${restaurantUrl}`, {tableNumber: tableNo});
                if (response.status === 200) {
                    setServiceType(response.data.storeConfig.PayFirst);
                    setStoreName(response.data.storeInformation.StoreName);
                    setStoreId(response.data.storeInformation.StoreId);
                    setStoreAddress(response.data.storeInformation.StoreAddress);
                    setStorePhone(response.data.storeInformation.StorePhone);
                    setFirstLanguage(response.data.storeConfig.FirstLanguage);
                    setSecondLanguage(response.data.storeConfig.SecondLanguage);
                    
                    // Set Customer Menu Show Price
                    setShowPriceInCustomerMenu(response.data.storeConfig.ShowPriceInCustomerMenu !== 0);
                    
                    //typeof language 
                
             

                    // const today = new Date();
                    // const dayOfWeek = today.getDay();
                    
                    // const state = response.data.storeInformation.Location;
                    
                    
                    // let surcharges;
                    // const isHoliday = await checkPublicHoliday(today, state);
                    // if (dayOfWeek === 0 || dayOfWeek === 6) {

                    //     surcharges = response.data.storeConfig.WeekendSurcharge;
                    //     setSurchargeDescription("Weekend Surcharge");
                    //     setSurcharges(surcharges);

                    // }
                    // else if (isHoliday)
                    //  {
                       
                       
                    //     surcharges =  response.data.storeConfig.WeekendSurcharge;
                    //     setSurchargeDescription("Public Holiday Surcharge");
                    //     setSurcharges(surcharges);
                        
                    // }

                  
                    // else {
                        
                    //         surcharges = response.data.storeConfig.Surcharge;
                    //         setSurcharges(surcharges);
                    //         setSurchargeDescription(response.data.storeConfig.SurchargeDescription);
                    // }

                    
                    

                    const {
                        MondayStart, MondayEnd,
                        TuesdayStart, TuesdayEnd,
                        WednesdayStart, WednesdayEnd,
                        ThursdayStart, ThursdayEnd,
                        FridayStart, FridayEnd,
                        SaturdayStart, SaturdayEnd,
                        SundayStart, SundayEnd
                    } = response.data.storeConfig;
                    setStoreTimetable({
                        Monday: { start: MondayStart, end: MondayEnd },
                        Tuesday: { start: TuesdayStart, end: TuesdayEnd },
                        Wednesday: { start: WednesdayStart, end: WednesdayEnd },
                        Thursday: { start: ThursdayStart, end: ThursdayEnd },
                        Friday: { start: FridayStart, end: FridayEnd },
                        Saturday: { start: SaturdayStart, end: SaturdayEnd },
                        Sunday: { start: SundayStart, end: SundayEnd }
                      });
                    
                }
            } catch (error) {
                console.error(error);
            }
        };
        // fetch table order if not paid
        const fetchTableOrder = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchTableOrder/${restaurantUrl}`, { tableNo });
                if (response.status === 200) {
                    
                    setOrders(response.data.order);
                    setNotes(response.data.order
                        .map(order => order.Notes) // 获取所有订单的 notes
                        .filter(note => note && note.trim()) // 移除空的或不存在的 notes，同时移除只包含空格的字符串
                        .join(", ")); // 用逗号和空格将剩余的 notes 连接成一个字符串
                    const totalSurcharge = response.data.order.reduce((total, order) => {
                        const orderSurcharge = parseFloat(((order.Surcharge * order.TotalAmount) / 100).toFixed(2));
                        return total + orderSurcharge;
                    }, 0);
                   
                    setSurcharges(totalSurcharge.toFixed(2));
                    
                    // Calculate total promotion amount
                    const totalPromotion = response.data.order.reduce((total, order) => {
                        return total + (parseFloat(order.PromotionAmount) || 0);
                    }, 0);
                    setTotalPromotionAmount(totalPromotion);
                    
                    // Get promotion title from first order that has one
                    const orderWithPromotion = response.data.order.find(order => order.PromotionTitle);
                    if (orderWithPromotion) {
                        setPromotionTitle(orderWithPromotion.PromotionTitle);
                    }
                    
                    const totalAmount = response.data.order.reduce((total, order) => {
                        return total + order.TotalAmount;
                    }, 0);
                    
                    setTotalAmount(totalAmount);
                    
                    // Calculate total item quantity
                    const totalItems = response.data.order.reduce((total, order) => {
                        const orderDetails = JSON.parse(order.OrderDetails);
                        const itemCount = orderDetails.reduce((sum, [_, mainItem]) => {
                            return sum + mainItem.quantity;
                        }, 0);
                        return total + itemCount;
                    }, 0);
                    setTotalItemQuantity(totalItems);
                    
                }

            } catch (error) {
                console.error('Error fetching table order:', error);
            }
        };
    
        // 调用内部定义的异步函数
        fetchStoreConfig();
        fetchTableOrder();

    }, [restaurantUrl, tableNo]); // 添加依赖项
    // const processOrder = async (orders) => {
    //     try {
    //         //for loop to get all the orders,const orderSummary = { Details: '', Total: 0 };
    //         console.log(orders);
    //         const orderSummary = { Details: '', Total: 0 };
    //         for (let i = 0; i < orders.length; i++) {
    //             orderSummary.Details += orders[i].OrderDetails;
    //         }
    //         console.log(orderSummary);
    //     }
    //     catch (error) {
    //         console.error('Error processing order:', error);
    //     }
    // };

                

    
    const checkPublicHoliday = async (today, state) => {
        const dateString = today.toISOString().split('T')[0];
        let holidays;
    
        switch (state) {
            case 'Melbourne':
                holidays = ['2023-12-25', '2023-12-26', '2024-01-01', '2024-01-26', '2024-03-29', '2024-03-30', '2024-03-31', '2024-04-01', '2024-04-25', '2024-06-10', '2024-08-05', '2024-10-07', '2024-12-25', '2024-12-26'];
                break;
            case 'Sydney':
                holidays = ['2023-12-25', '2023-12-26', '2024-01-01', '2024-01-26', '2024-03-29', '2024-03-30', '2024-03-31', '2024-04-01', '2024-04-25', '2024-06-10', '2024-08-05', '2024-10-07', '2024-12-25', '2024-12-26'];
                break;
            case 'Brisbane':
                holidays = ['2023-12-25', '2023-12-26', '2024-01-01', '2024-01-26', '2024-03-29', '2024-03-30', '2024-03-31', '2024-04-01', '2024-04-25', '2024-05-01', '2024-08-16', '2024-10-02', '2024-12-25', '2024-12-26'];
                break;
            default:
                return false;
        }
    
        return holidays.includes(dateString);
    };
    

  return (
    <div className="container" style={{background:'#f1f1f1', minHeight: '100vh'}}>
    <div className="header">
        <div className="box">
            <div className="left">
                <div className="item">
                        <img src="/img/icon1.svg" id="btn3" onClick={toggleSidePopup}/>
                    </div>
                    <div>
                    {storeName}</div>
            </div>
            <div className="right">
                <div className="item">
                    <a onClick={ClickOrderMoreButton}>
                        <img src="/img/icon6.svg"/>
                    </a>
                </div>
                {/* <div className="item" id="btn">
                    <img src="/img/icon7.svg"/>
                </div>
                <div className="yyqh" style={{display: 'none'}}>
                    <div className="item2">中文</div>
                    <div className="item2">English</div>
                    <div className="item2">한국어</div>
                    <div className="item2">日本語日本語日本語日本語日本語</div>
                </div> */}
            </div>
        </div>
    </div>

    <header className="mui-bar mui-bar-transparent">
    {/* /QROrder/:restaurantUrl/menu */}
        <a className="mui-action-back zdy_bar_icon" onClick={ClickOrderMoreButton}>
            <img src="/img/icon2.svg"/>
        </a>

        <h1 className="mui-title">{ui('orderSummary')}</h1>
    </header>


    <div style={{height: '44px'}}></div>
    <div className="container-fluid">
        <div className="zdy_card2">
            <div className="cell">
                
            <span style={{ fontWeight: 'bold' }}>
            {serviceMode === 'Dine-in' ? ui('dinein') : ui('takeaway')}
            </span>
                
            </div>
            {serviceMode === 'Dine-in' && (
            <div className="cell">
                <span>{ui('tableNo')}</span>
                <b>{tableNo}</b>
            </div>
            )}

        </div>
        <div className="zdy_card2">
            <div className="title">
                {/* <img src="/img/dish.svg"/> */}
                <span>{ui('menuItems')}</span>
            </div>
 
            <div>
                {Orders.map((order) => (
                    <div key={order.OrderId}>
                    {/* <h2>订单ID: {order.OrderId}</h2> */}
                    <ul>
                        {JSON.parse(order.OrderDetails).map(([_, item, ...extraItems]) => (
                        <React.Fragment key={item.mainItemCode}>
                            <li key={item.mainItemCode}>
                            <span style={{ fontWeight: "600" ,marginRight:"30px",marginBottom:"3px"}}>{item.mainItemDescription} x {item.quantity}</span>
                            <span>{showPriceInCustomerMenu ? `$${(item.quantity * item.price).toFixed(2)}` : '\u00A0'}</span>
                            </li>
                            {extraItems.length === 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
                            {extraItems.map((extraItem) => (
                            <li key={extraItem.itemCode}>
                                <span style={{paddingLeft:"14px",fontSize:"13px",marginTop:"-12px"}}> {extraItem.itemDescription} x {extraItem.quantity}</span>
                                <span style={{fontSize:"13px",marginTop:"-12px"}}>{showPriceInCustomerMenu ? `$${(extraItem.quantity * extraItem.price).toFixed(2)}` : '\u00A0'}</span>
                            </li>
                            ))}
                            {extraItems.length !== 0 && <li style={{ borderBottom: "1px solid #e6e6e6" }}></li>}
                        </React.Fragment>
                        ))}
                    </ul>
                    </div>
                ))}
            </div>
            </div>
            {notes&&<div className="zdy_card2">
                <div className="title">
                    <span>{ui('notes')}</span>
                </div>
                        <ul>
                            <li>
                                <span>{notes}</span>
                            </li>
                        </ul>
                </div>}

       
        <div className="zdy_card2">
            <ul>
               
                {/* <li>
                    <span>GST</span>
                    <span>${totalGST}</span>
                </li> */}
              
                {promotionTitle && totalPromotionAmount > 0 && (
                    <li style={{ color: 'rgb(252 158 86)' }}>
                        <span style={{ fontWeight: '600' }}>{promotionTitle}</span>
                        <span style={{ fontWeight: '600' }}>{showPriceInCustomerMenu ? `-$${totalPromotionAmount.toFixed(2)}` : '\u00A0'}</span>
                    </li>
                )}
              
                {surcharges > 0 &&
                <li>

                    <span>Surcharge</span>
                    <span>{showPriceInCustomerMenu ? `$${surcharges}` : '\u00A0'}</span>
                </li>}
                <li>
                    <span style={{fontWeight: 'bold'}}>{showPriceInCustomerMenu ? ui('total') : `Total Items: ${totalItemQuantity}`}</span>
                    <b>{showPriceInCustomerMenu ? `$${totalAmount.toFixed(2)}` : '\u00A0'}</b>


                </li>
            </ul>
        </div>
        <div style={{height: '70px'}}></div>
       <div className="fixed-bottom bg-white" style={{padding: '8px 16px'}}>
            <button onClick={() => ClickOrderMoreButton()} type="button" className="btn btn-warning btn-block">{ui('orderMore')}</button>
        </div>


    </div>

    <div className={`side_popup ${side_popup ? 'show' : ''}`}>
            <div className="bg"></div>
            <div className="popup_box">
                <img src="/img/icon3.svg" className="close" id="btn4" onClick={toggleSidePopup}/>
                <div className="side_popup_t1">
                    {storeId && <img crossOrigin="anonymous" src={`${process.env.REACT_APP_SERVER_URL}/storeIcon/${storeId}`} onError={(e) => { e.target.onerror = null; e.target.src = '/img/default_top_icon.png';}}/>}
                </div>
                <div className="side_popup_t2">{storeName}</div>
                <div className="side_popup_t3">
                    <p className="text1">{ui('openingHours')}</p>
                    <div>
                        {getStoreTimetable() && Object.entries(getStoreTimetable()).map(([day, hours]) => 
                            <p key={day} className="text2">
                                {day}: <span className='text3'>    {
                        (hours && hours.start !== null && hours.end !== null) 
                        ? ` ${hours.start} - ${hours.end}` 
                        : "Closed"
                    }</span>
                            </p>
                        )}
                    </div>
                </div>
                <div className="side_popup_t3">
                    {/* <p className="text1">Contact Number:</p> */}
                    <p className="text2"> <img src="/img/icon4.svg"/> {storePhone}</p>
                    <p className="text2"> <img src="/img/icon5.svg"/> {storeAddress}</p>
                </div>
                <div className="footer">
                    <div className="r1">
                        Powered by <img src="/img/ipos_logo.png"/>
                    </div>
                    {/* <div className="r2">
                        Beautiful menus for QR code table ordering, pickup delivery and payments.
                    </div> */}
                    <div className="r3">
                        <a href="https://www.i-pos.com.au/">{ui('learnMore')}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  );
}

export default OrderReview;